import { render, staticRenderFns } from "./OptionInfo.vue?vue&type=template&id=29cd2627&scoped=true"
import script from "./OptionInfo.vue?vue&type=script&lang=js"
export * from "./OptionInfo.vue?vue&type=script&lang=js"
import style0 from "./OptionInfo.vue?vue&type=style&index=0&id=29cd2627&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cd2627",
  null
  
)

export default component.exports